import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { SITE, img, openEnquiry } from "../config";
import { trackEvent } from "../analytics";

const NAV = [
    { to: "/", label: "Home", id: "home" },
    { to: "/1-bhk/", label: "1 BHK", id: "1-bhk" },
    { to: "/2-bhk/", label: "2 BHK", id: "2-bhk" },
    { to: "/3-bhk/", label: "3 BHK", id: "3-bhk" },
    { to: "/floor-plans/", label: "Floor Plans", id: "floor-plans" },
    { to: "/amenities/", label: "Amenities", id: "amenities" },
    { to: "/location/", label: "Location", id: "location" },
    { to: "/contact/", label: "Contact", id: "contact" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    const linkCls = ({ isActive }) =>
        `text-[13px] font-bold uppercase tracking-wider transition-colors duration-150 ${
            isActive ? "text-[#6e6234]" : "text-[#23231f] hover:text-[#6e6234]"
        }`;

    return (
        <header className="sticky top-0 z-50 border-b border-[#ded8c6] bg-[#f7f4ec]/95 backdrop-blur">
            <div className="container-x flex h-16 items-center justify-between gap-4">
                <Link to="/" className="flex items-center gap-2.5" data-testid="header-logo">
                    <img src={img("emblem")} alt="Atlanta Enclave logo" width="30" height="23" className="h-8 w-auto" />
                    <span className="font-display text-lg font-semibold tracking-wide text-[#23231f]">
                        Atlanta Enclave <span className="hidden text-sm font-normal text-[#8a877a] sm:inline">Shilphata</span>
                    </span>
                </Link>

                <nav className="hidden items-center gap-6 lg:flex" data-testid="main-nav" aria-label="Main navigation">
                    {NAV.map((n) => (
                        <NavLink key={n.id} to={n.to} end={n.to === "/"} className={linkCls} data-testid={`nav-link-${n.id}`}>
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href={SITE.phoneTel}
                        onClick={() => trackEvent("call_click", { placement: "header" })}
                        className="hidden items-center gap-2 px-3 py-2 text-sm font-bold text-[#23231f] hover:text-[#6e6234] md:inline-flex"
                        data-testid="header-call-button"
                    >
                        <Phone size={15} /> {SITE.phoneDisplay}
                    </a>
                    <button onClick={openEnquiry} className="btn btn-gold hidden !px-5 !py-2.5 sm:inline-flex" data-testid="header-get-price-button">
                        Get Price
                    </button>
                    <button
                        className="p-2 lg:hidden"
                        onClick={() => setOpen(!open)}
                        aria-label="Toggle menu"
                        aria-expanded={open}
                        data-testid="mobile-menu-toggle"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {open && (
                <nav className="border-t border-[#ded8c6] bg-[#f7f4ec] lg:hidden" aria-label="Mobile navigation" data-testid="mobile-nav">
                    <div className="container-x grid gap-1 py-4">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.id}
                                to={n.to}
                                end={n.to === "/"}
                                onClick={() => setOpen(false)}
                                className="border-b border-[#efeadb] py-3 text-sm font-bold uppercase tracking-wider text-[#23231f]"
                                data-testid={`mobile-nav-link-${n.id}`}
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </div>
                </nav>
            )}
        </header>
    );
};
